// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    export enum PricingType {
  SellPriceOnly = 0,
  PricingBreakout = 1,
  PricingBreakoutByArea = 2,
  SellPriceOnlyByArea = 3,
  SellPriceOnlyPricingBreakoutByArea = 4,
  PricingBreakoutSellPriceOnlyByArea = 5,
  AreaSellPriceOnly = 6,
  AreaPricingBreakoutOnly = 7,
  NoPricingSummary = 8,
}
